import EventEmitter from "base/EventEmitter";
import Ajax from "base/Ajax";
import Message from "base/Message";
import FieldEditor from "editor/FieldEditor";
import ToolbarItemBasic from "toolbar/ToolbarItemBasic";
import ToolbarItemRevisions from "toolbar/ToolbarItemRevisions";
import Toolbar from "toolbar/Toolbar";
import RevisionSidebar from "sidebar/RevisionSidebar";
import ValueHelper from "base/ValueHelper";
import ConfirmModal from "modal/ConfirmModal";
import ContentPostSettingsModal from "content/ContentPostSettingsModal";

class ContentPost extends EventEmitter {

    constructor($elem, data = null) {
        super();

        this.editing = false;
        this.revisions = [];
        this.editors = {};

        this.$elem = $elem;

        this.id = $elem.attr("data-content-post");
        this.loadContentType($elem.attr("data-content-type"));

        this.$elem.addClass("content-post");

        this.loadPost(data);

        this.buildSidebar();
        this.buildControls();
        this.bindEvents();

        if ('undefined' === typeof this.id || this.id === '') {
            setTimeout(() => this.startEditing());
        }
    }

    static register_post_editor(content_type, clazz) {
        if (!ContentPost.editors) {
            ContentPost.editors = {};
        }
        ContentPost.editors[content_type] = clazz;
    }

    /**
     *
     * @param $item
     * @returns {ContentPost}
     */
    static process($item, data = null) {
        if (!ContentPost.editors) {
            ContentPost.editors = {};
        }

        let content_type = $item.attr("data-content-type");
        let editor;

        if ('undefined' === typeof ContentPost.editors[content_type]) {
            editor = ContentPost;
        } else {
            editor = ContentPost.editors[content_type];
        }

        let instance = new editor($item, data);

        $item.data("editor", instance);

        return instance;
    }

    static get_content_type(id) {
        if ('undefined' === typeof ContentPost.content_types) {
            ContentPost.content_types = {}
        }
        if ('undefined' === typeof ContentPost.content_types[id]) {
            ContentPost.content_types[id] = Ajax.get('content', id);
        }
        return ContentPost.content_types[id];
    }

    getContentType() {
        return this.getContentTypePromise;
    }

    buildSidebar() {
        this.revisionsSidebar = new RevisionSidebar((page) => this.loadRevisions(page), (revisionId) => {
            this.revisions.forEach((revision) => {
                if (revisionId === revision.id) {
                    this.setRevision(revision);
                    revision.active = true;
                } else {
                    revision.active = false;
                }
            });
        });
    }

    buildControls() {
        this.$controls = (
            eotwJSXFactory('div', {class: "bottom-controls"}, [
                eotwJSXFactory('button', {class: "js-save admin-btn admin-btn--confirm"}, ["Save & Publish"]),
                eotwJSXFactory('button', {class: "js-cancel admin-btn admin-btn--cancel"}, ["Cancel"])
            ])
        );

        const me = this;
        this.$controls.on("click", ".js-save", function () {
            let $this = $(this);
            if ($this.is(".admin-btn--loading")) return false;
            $this.addClass("admin-btn--loading");
            me.save().then(() => {
                $this.removeClass("admin-btn--loading");
                new Message('You have updated the item successfully', undefined, Message.SUCCESS);
            }).catch((e) => {
                new Message(e.message, "Couldn't save the item");
                console.log(e);
                $this.removeClass("admin-btn--loading");
            });
            return false;
        }).on("click", ".js-cancel", () => {
            this.confirmCancel();
            return false;
        });

        $("body").append(this.$controls.hide());
    }

    bindEvents() {
        this.toolbarItems = {
            startEditing: new ToolbarItemBasic('Begin Editing', () => this.startEditing(), 'pencil'),
            cancel: new ToolbarItemBasic('Cancel', () => this.confirmCancel(), 'cancel'),
            settings: new ToolbarItemBasic('Settings', () => this.showSettings(), 'cog'),
            revisions: new ToolbarItemRevisions(() => this.toggleRevisions()),
        };
    }

    loadRevisions(page) {
        let revisions;
        return this.getPost()
            .then((post) => Ajax.get(null, post.href + '/revisions', {page: page, depth: 11}))
            .then((_revisions) => revisions = _revisions)
            .then(() => this.getCurrentRevision()).then((currentRevision) => {
                revisions.forEach((revision) => {
                    revision.active = revision.id === this.workingRevision.id;
                    revision.current = currentRevision.id === revision.id;
                    revision.user = revision.author;
                });
                this.revisions = this.revisions.concat(revisions);
                return revisions;
            });
    }

    showSettings() {
        let modal = new ContentPostSettingsModal(this);

        this.emit('openSettings', modal);

        modal.on("cancel submit", () => {
            modal.destroy();
        });

        modal.show();
    }

    toggleRevisions() {
        this.revisionsSidebar.toggle();
    }

    loadContentType(content_type) {
        this.getContentTypePromise = ContentPost.get_content_type(content_type).then((data) => {
            this.getContentTypePromise = Promise.resolve(data);
            return data;
        }).catch((e) => {
            new Message(e.message, "Couldn't load the content type.");
        });
    }

    loadPost(data = null) {
        if (!this.id) {
            let empty = {activeRevision: {values: {}}};

            if (this.$elem.find(".js-content-post-data").length === 1) {
                let $data = this.$elem.find(".js-content-post-data");
                try {
                    empty.activeRevision.values = JSON.parse($data.text());
                    this.getPostPromise = Promise.resolve(empty)
                } catch (e) {
                    console.log("Couldn't load content post data", e);
                    $data.remove();
                    this.loadPost();
                }
            } else {
                this.getPostPromise = this.getContentType().then((content_type) => {
                    Object.keys(content_type.inputs).forEach((key) => {
                        let input = content_type.inputs[key];

                        empty.activeRevision.values[key] = input.type.defaultValue;
                    });

                    this.getPostPromise = Promise.resolve(empty);

                    return empty;
                });
            }
            return;
        }
        this.getPostPromise = this.getContentType().then((content_type) => {
            if (this.emit("addStartToolbarItem")) {
                Toolbar.addDefaultItem(this.toolbarItems.startEditing);
            }
            return data !== null ? data : Ajax.get(null, content_type.href + '/posts/' + this.id, {depth: 11})
        }).then((data) => {
            this.getPostPromise = Promise.resolve(data);
            return data;
        }).catch((e) => {
            new Message(e.message, "Couldn't load the current revision.");
        });
    }

    delete() {
        let prom;
        if (!this.id) {
            prom = Promise.resolve();
        } else {
            prom = this.getPost().then((post) => Ajax.delete(null, post.href))
        }

        return prom;
    }

    getPost() {
        return this.getPostPromise;
    }

    getCurrentRevision() {
        return this.getPost().then((post) => post.activeRevision);
    }

    startEditing() {
        try {
            if (this.editing || !this.emit('startEditing')) return;
            this.editing = true;


            let revision;
            return this.getCurrentRevision().then((_revision) => {
                revision = _revision;
            }).then(() => this.enableInputs()).then((editors) => {
                this.editors = editors;

                let toolbarItemsLeft = [this.toolbarItems.cancel, this.toolbarItems.settings];
                let toolbarItemsRight = this.id ? [this.toolbarItems.revisions] : [];

                if (this.emit("toolbarItems", {left: toolbarItemsLeft, right: toolbarItemsRight})) {
                    Toolbar.setItems(toolbarItemsLeft, Toolbar.LEFT);
                    Toolbar.setItems(toolbarItemsRight, Toolbar.RIGHT);
                }

                if (this.emit("showControls")) {
                    this.$controls.show();
                }
                this.$elem.addClass("content-post--editing");

                this.setRevision(revision);
                this.emit("editingStarted");
            }).catch((e) => {
                new Message(e.message, "Couldn't begin editing.");
                console.log(e);
            });
        } catch (e) {
            new Message(e.message, "Couldn't begin editing.");
            console.log(e);
            return Promise.reject(e);
        }
    }

    updateWorkingRevision() {
        this.workingRevision.values = $.extend(this.workingRevision.values, this.getInputData());
    }

    save() {
        this.updateWorkingRevision();
        let prom;
        let data = $.extend({depth: 11}, this.workingRevision);
        if (this.id) {
            prom = this.getPost().then((post) => Ajax.put(null, post.href, data))
        } else {
            prom = this.getContentType().then((content_type) => Ajax.post('content', content_type.id + '/posts/', data));
        }

        return prom.then((data) => {
            if (!this.id) {
                if (this.emit('itemAdded')) {
                    Message.schedule(new Message('You have added the new item successfully', undefined, Message.SUCCESS));
                    window.location.href = data.url;
                    return new Promise(() => {
                        /*Return a promise that will never resolve*/
                    });
                }
                this.id = data.id;
            }

            this.getPostPromise = Promise.resolve(data);
            this.setRevision(data.activeRevision);
            this.stopEditing();
        });
    }

    setRevision(revision) {
        this.emit("setRevision", revision);
        let workingRevision = $.extend(true, {}, revision);
        this.workingRevision = workingRevision;

        this.setInputData(workingRevision.values);
    }

    stopEditing() {
        if (!this.editing || !this.emit('stopEditing')) return;
        this.editing = false;
        this.disableInputs();
        if (this.emit("resetToolbarItems")) {
            Toolbar.reset();
        }

        this.$controls.hide();
        this.$elem.removeClass("content-post--editing");

        this.revisionsSidebar.close();

        this.emit("stoppedEditing");
    }

    hasChanged() {
        this.updateWorkingRevision();
        return this.getCurrentRevision().then((currentRevision) => !ValueHelper.obj_compare(this.workingRevision.values, currentRevision.values));
    }

    confirmCancel() {
        return this.hasChanged()
            .then((changed) => changed ? ConfirmModal.confirm('You will lose any unsaved changes') : true)
            .then(() => this.cancel());

    }

    cancel() {
        if (!this.id) {
            window.location = window.CONFIG.urls.website;
            return new Promise(() => {
                //Unresolved promise
            });
        }

        return this.getCurrentRevision()
            .then(this.setRevision.bind(this))
            .then(() => this.stopEditing())
            .catch((e) => new Message(e.message, "Couldn't cancel editing"));
    }

    enableInputs() {
        return this.getContentType().then((contentType) => {
            this.emit('enableInputs', {contentType: contentType});
            let editors = {};

            Object.values(contentType.inputs).forEach((input) => {
                let editor = this.enableInput(input);
                if (editor instanceof FieldEditor) {
                    editors[input.slug] = editor;
                }
            });
            this.emit('enabledInputs', {contentType: contentType, editors: editors});

            return editors;
        });

    }

    enableInput(input, $field = null) {
        if ($field === null) {
            $field = this.$elem.find("[data-field='" + input.slug + "']");
        }

        let data = {$input: $field, input: input};
        try {
            if (this.emit('enableInput.' + input.slug, data) && $field.length > 0) {
                return FieldEditor.get_editor(input.type.editor, $field, input.settings);
            } else if ('undefined' !== typeof data.editor) {
                return data.editor;
            }
        } catch (e) {
            console.error("Couldn't enable input", data, e);
        }
    }

    disableInputs() {
        if (!this.emit('disableInputs')) return;

        Object.values(this.editors).forEach((editor) => editor.destroy());
        this.editors = {};
    }

    getInputData() {
        let data = {};

        Object.keys(this.editors).forEach((slug) => {
            data[slug] = this.editors[slug].getValue();
        });

        return data;
    }

    setInputData(data) {
        Object.keys(data).forEach((slug) => {
            if (this.editing && this.editors[slug] instanceof FieldEditor) {
                this.editors[slug].setValue(data[slug]);
            } else {
                this.workingRevision.values[slug] = data[slug];
            }
        });

        this.updateWorkingRevision();
    }
}

export default ContentPost;
